import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsSwumAi() {
    return <ComparisonPage slug="swum-ai" />;
}
